
// Function to dynamically generate wave options
const generateWaveOptions = (count) => {
    return Array.from({ length: count }, (_, index) => ({
      value: `wave${index + 1}`,
      label: `Wave ${index + 1}`,
    }));
  };
 export const formFields = [
    {
        id: "name",
        label: "Project Name",
        placeholder: "Enter project name",
        isMandatory: true,
        type: "input",
        required: true,
        section: "up",
    },
    {
        id: "client_name",
        label: "Client Name",
        placeholder: "Enter client name",
        isMandatory: true,
        type: "input",
        required: true,
        section: "up",
    },
    {
        id: "description",
        label: "Description",
        placeholder: "Enter the detailed project objective",
        type: "textarea",
        optional: true,
        section: "down",
    },
];

export const MVOCFORM = [
    {
        id: "asset_name",
        label: "Asset Name",
        placeholder: "Enter asset name",
        isMandatory: true,
        type: "input",

        section: "up",
    },
    {
        id: "indication_name",
        label: "Indication Name",
        placeholder: "Enter indication name",
        isMandatory: true,
        type: "input",
        section: "up",
    },
    {
        id: "manufacturer_name",
        label: "Manufacturer Name",
        placeholder: "Enter manufacturer name",
        type: "input",
        isMandatory: true,
        optional: false,
        section: "up",
    },
    {
        id: "wave_name",
        label: "Wave",
        placeholder: "Select wave",
        type: "dropdown",
        isMandatory: true,
        onOpenFunctionParam: "wave",
        section: "down",
        options:generateWaveOptions(15),
    },
    {
        id: "prompt_name",
        label: "Prompt",
        placeholder: "Select prompt",
        type: "dropdown",
        isMandatory: true,
        onOpenFunctionParam: "prompt",
        section: "down",
        options:[{value:"prompt 1",label:"Prompt 1"},{value:"prompt 1 Updated",label:"Prompt 1 Updated"}],
    },
];
console.log(generateWaveOptions(15),">>>>>>>>>>>>>>>>>");